import firebase from '../firebase/firebase';
import { toArray } from '../utils/lodashUtils';
import { makeUniqueId } from '../utils/database/database-utils';

const moment = require('moment-timezone');
const db = firebase.database();

class MessageBackEnd {
    
    uid = '';
    messageRef = null;
    myRef = null;
    initialMessagesLoaded = false;

    loadMessages = (callback, user, serviceId, receiverId, channel, type = 'message') => {
        return new Promise((resolve, reject) => {
            console.log('load Messages @ ChatBackend',  user, serviceId, receiverId, channel, type);

            const messagesRef = db.ref(`/${type}s/${channel}`);
            messagesRef.off();
            
            const onReceive = (snap) => {
                const message = snap.val();
                console.log('LOADING MESSAGES...');
                if (message && this.initialMessagesLoaded) {
                    console.log('NEW MESSAGE ARRIVED', message);
                    messagesRef.orderByKey().limitToLast(20).once('value', messagesSnap => {
                        console.log('GOT ALL INITIAL MESSAGES @ ChatBackend', snap.val());
                        resolve(toArray(messagesSnap.val()));
                        this.initialMessagesLoaded = true;
                    }, e => console.log);
                } else {
                    console.log('COULD NOT RETRIEVE MESSAGE', message);
                }
            };
    
            const onFail = (error) => {
                // console.log('FIREBASE ERROR',  error);
            }
            
            // THIS GETS ALL SUBSEQUENT RECEIVED MESSAGES FROM THE DATABASE
            messagesRef.orderByKey().limitToLast(20).on('child_added', onReceive, onFail);
            messagesRef.orderByKey().limitToLast(20).on('child_changed', onReceive, onFail);
            
            // THIS GETS ALL THE INITIAL MESSAGES FROM THE DATABASE
            messagesRef.orderByKey().limitToLast(20).once('value', snap => {
                console.log('GOT ALL INITIAL MESSAGES @ ChatBackend', snap.val());
                resolve(toArray(snap.val()));
                this.initialMessagesLoaded = true;
            }, e => console.log);
        });
    }

    // @TODO: COMMENTS NEED TO BE REWRITTEN WITHOUT THREADS

    attachLogComment = ({ commentBy, commentText, channel, logId, createdAt}) => {
        // console.log('ATTACHING LOG COMMENT', null);
        const messageRef = db.ref(`/nutritionLogs/${channel}/${logId}/comments/`);
        const key = messageRef.push().key;
        messageRef.child(key).set({
            _id: key,
            commentBy,
            commentText,
            createdAt,
        });
    }

    setLogLikedStatus = ({ logId, isChecked, checkedBy, channel }) => {
        // console.log('LIKED: logId, isChecked, channel', logId, isChecked, channel);
        
        const messageLikedRef = db.ref(`/nutritionLogs/${channel}/${logId}/likes/`);
        messageLikedRef.set({
            checkedBy,
            isChecked,
        });
    }
    
    setLogReviewedStatus = ({ logId, isChecked, checkedBy, channel }) => {
        // console.log('Reviewed: logId, isChecked, channel', logId, isChecked, channel);
        const messageReviewedRef = db.ref(`/nutritionLogs/${channel}/${logId}/reviews/`);
        messageReviewedRef.set({
            checkedBy,
            isChecked,
        });
    }

    //Gets another set of 20 messages from database and displays them.
    // moreMessages = (callback, receiverId, lastMessageId, channel, serviceId = null, type = 'message') => {
    //     // const messageType = (type === 'message') ? 'messages': 'nutritionLogs';
    //     this.myRef = db.ref(`/${type}s/${channel}`);
    //     this.myRef.off();

    //     const onReceive = (messagesSnap) => {
    //         const messages = messagesSnap.val();
    //         // console.log('MESSAGES @ more mess', messages);
            
    //         // callback({
    //         //     _id: messagesSnap.key,
    //         //     text: messages.text,
    //         //     receiver_id: receiverId,
    //         //     createdAt: new Date(messages.createdAt), // TODO: convert to local time here from UTC - TODO
    //         //     senderId: messages.senderId,
    //         //     // liked: message.liked,
    //         //     // comment: message.comment
    //         // });
    //         const messagesArray = toArray(messages);
    //         // console.log('messarray @ more mess', messagesArray);
            
    //         callback(messagesArray);
    //     };
    //     // console.log('LAST MESSAGE ID', lastMessageId);
        
    //     this.myRef.orderByKey().limitToLast(20).endAt(lastMessageId).on('value', onReceive);
    // }

    sendMessage = async ({message, createdAt, receiverId, threadId, senderId, photoFile, type, linkData, serviceId, uploadDoneCb}) => { //possibly send in channel and service id here so not relying on this.messageRef which is confusing
        // console.log('MESSAGE SENDING', message);
        let chatPhotoURL = null;

        if (photoFile) {
            chatPhotoURL = await _getImageURL({
                dbNodeId: senderId,
                imageData: photoFile,
                imageType: `${type}Photo`,
            });

            // console.log(`%cDone photo upload.`,'color: greenyellow', chatPhotoURL );
            
            if (chatPhotoURL && (type === 'nutritionLog' || type === 'message')) {
                console.log(`%cSending upload done signal to react callback.`,'color: greenyellow');
                uploadDoneCb();
            }
        }
        const messagesRef = db.ref(`${type}s/${threadId}`);
        const messageKey = messagesRef.push().key;
        // console.log('MESSAGE', message);
        let data;
        const commonData = {
            _id: messageKey,
            createdAt,
            receiverId,
            senderId,
            serviceId,
            threadId,
        }
        if (type === 'nutritionLog') {
            data = {
                ...commonData,
                mealDescription: message.mealDescription,
                mealTitle: message.mealTitle,
                photoURL: (chatPhotoURL) ? chatPhotoURL : null,
            }
        }
        if (type === 'message') {
            // console.log('commonData, message.text', commonData, message.text);
            
            data = {
                ...commonData,
                photoURL: (chatPhotoURL) ? chatPhotoURL : null,
                text: message.text,
            }
        }
        if (type === 'link') {
            // console.log('commonData, message.text', commonData, message.text);
            if (linkData.linkType === 'document') {
                data = {
                    ...commonData,
                    documentLink: linkData.documentLink,
                    documentTitle: linkData.documentTitle,
                    linkType: linkData.linkType,
                }
            } 
            if (linkData.linkType === 'video') {
                data = {
                    ...commonData,
                    linkType: linkData.linkType,
                    videoLink: linkData.videoLink,
                    videoTitle: linkData.videoTitle,
                }
            }
        }
        messagesRef.child(messageKey).set(data);
    }
   
} //end MessageBackEnd

const uploadFileToFs = (path, file, cb) => {
    const logoStorageRef = firebase.storage().ref(path);
    let uploadTask = logoStorageRef.put(file);

    uploadTask.on('state_changed', (snap) => {
        switch (snap.state) {
            case 'paused':
                console.log('Upload is paused.');
                break;
            case 'running':
                console.log('Upload task is running...');
                break;
            case 'complete':
                console.log('Upload complete.');
                // call script to turn off spinner
                break;
        }
    }, error => {
        switch (error.code) {
            case 'storage/unauthorized':
                // console.log('Upload permission denied: You dont have permission to upload to this location...');
                break;
            case 'storage/canceled':
                // console.log('Upload canceled by user.');
                break;
            case 'storage/unknown':
                // console.log('Error: unknown error occurred. Upload failed.');
                break;
        }
    }, () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // console.log('uploadFileToFs - downloadURL', downloadURL);
            cb(downloadURL);
        });
    });
};
// function _isImage(ext) {
//     switch(ext.toLowerCase()) {
//         case 'jpg':
//         case 'jpeg':
//         case 'png':
//         case 'gif':
//         return true;
//     }
//     return false;
// }

// function _getExtension(filename) {
//     var parts = filename.split('.');
//     return parts[parts.length - 1];
// }

const _getImageURL = ({imageData, dbNodeId, imageType}) => {
    // console.log('_getImageURL- called');
    // console.log('_getImageURL', imageData, dbNodeId, imageType);
      
    return new Promise(function(resolve, reject) {
        if (imageType && (imageType === 'messagePhoto' || imageType === 'nutritionLogPhoto')){
            if(imageData){
                let fs_imageBasePath = `${imageType}s`;
                const fs_path = `${fs_imageBasePath}/${dbNodeId}/${makeUniqueId(imageData.name, 10)}`;
                const file = imageData;
                
                uploadFileToFs(fs_path, file, (downloadURL) => {
                    resolve(downloadURL);
                });
            } else {
                reject(new Error('No imageData option passed to _getImageURL function.'));
                return null;
            }
        } else if (!imageType){
            reject(new Error('No imageType has been provided to _getImageURL function.')); 
            return null;
        } else {
            reject(new Error('Please provide a valid imageType to _getImageURL function.')); 
            return null;
        }
    });
}

export default new MessageBackEnd();



// WEBPACK FOOTER //
// ./src/js/utils/ChatBackend.js